<template>
  <SettingsPageLayout>
    <card extra-classes="w-11/12 max-w-3xl mx-auto text-center py-24">
      <h1 class="block text-2xl font-bold leading-6 text-gray-900">Recruiting Landing Pages</h1>
      <p class="text-gray-600 mt-2">
        Humaniz landing pages give you another avenue to recruit the perfect candidates. Not every top performer is
        actively looking at job posts, but you can use a Humaniz landing page to share on social media, business cards,
        and more.
      </p>

      <div class="mt-12 flex justify-center items-center gap-5">
        <button
          class="relative flex items-center rounded bg-[#fde68a] px-3 py-2 text-sm font-semibold text-slate-900 ring-1 ring-inset ring-[#fde68a] hover:bg-[#f7d286] focus:z-10"
          @click="createSite"
        >
          Create your landing page
        </button>
        <a
          href="https://www.joinhumaniz.com"
          target="_blank"
          class="text-sm text-indigo-600 hover:text-indigo-900"
          data-track="clicked-view-landing-page-demo"
          >View demo</a
        >
      </div>
    </card>
  </SettingsPageLayout>
</template>

<script>
import Card from '../../Card/index.vue';
import SettingsPageLayout from '../../SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';

export default {
  components: {
    Card,
    SettingsPageLayout,
    DetailForm,
  },
  methods: {
    async createSite() {
      const res = await fetch('/api/site_pages', {
        method: 'POST',
        headers: {
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      });

      const data = await res.json();

      if (data.status === 'success') {
        await this.$router.push('/settings/company/landing_pages');
      } else {
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Landing page error',
          alertDescription: data.message,
        });
      }
    },
  },
};
</script>
